module.exports = __webpack_public_path__ + "assets/images/05R.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/05R.png
// module id = 1267
// module chunks = 1